import React from 'react';
import { services, features } from '../../data/mock';
import { ArrowUpRight } from 'lucide-react';

export default function Services() {
  return (
    <section id="servizi" className="py-24 lg:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="text-sky-600 text-xs font-bold uppercase tracking-[0.2em]">I nostri servizi</div>
            <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">Soluzioni complete per privati e aziende</h2>
            <p className="mt-4 text-slate-600 text-lg leading-relaxed">Multi-marca, multi-piattaforma. Dal singolo smartphone alla rete aziendale: un unico interlocutore di fiducia.</p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="group relative bg-white rounded-2xl p-7 border border-slate-200 hover:border-sky-300 hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="w-12 h-12 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center group-hover:bg-sky-600 group-hover:text-white transition-colors">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-5 text-xl font-bold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-slate-600 leading-relaxed text-sm">{s.description}</p>
                <ArrowUpRight className="absolute top-7 right-7 w-5 h-5 text-slate-300 group-hover:text-sky-600 transition-colors" />
              </div>
            );
          })}
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {features.map((f) => {
            const Icon = f.icon;
            return (
              <div key={f.label} className="flex items-center gap-3 px-5 py-4 bg-white rounded-xl border border-slate-200">
                <Icon className="w-5 h-5 text-sky-600 flex-shrink-0" />
                <span className="text-slate-800 font-medium text-sm">{f.label}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
